module.exports = __webpack_public_path__ + "static/media/ic_cajero_seleccionado.085a1652.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_cajero_seleccionado.webp
// module id = 177
// module chunks = 1